import React, {useEffect, useState} from 'react';
import '../../styles/calculator.scss';
import {Box, CircularProgress, useMediaQuery} from "@mui/material";
import {t} from "i18next";
import {useDispatch, useSelector} from "react-redux";
import {setContactId, setToken} from "../store/userReducer";
import {theme} from "../../styles/theme";
import {WeightUnit} from "../../models";
import CountryInput, {Country} from "./country-input";
import {api, getQuote, getToken, getUserInfo} from "../common/api";
import WeightInput from "./weight-input";
import DeliveryMethodsList from "./delivery-methods-list";

function Calculator() {

    const dispatch = useDispatch();
    const token = useSelector((state: any) => state.user.accessToken);
    const contactId = useSelector((state: any) => state.user.contactId);

    const [originCountry, _] = useState<Country | null>({countryCode: "US", name: "United States"});
    const [destinationCountry, setDestinationCountry] = useState<Country | null>(null);

    const [weight, setWeight] = useState<string | null>("");
    const [weightUnit, setWeightUnit] = useState<WeightUnit | null>(WeightUnit.Kg);

    const [deliveryMethods, setDeliveryMethods] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState(false)
    const [sort, setSort] = useState(false)
    const [isNothingFound, setIsNothingFound] = useState(false)

    const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

    const handleSubmit = () => {

        if (!destinationCountry)
            return;

        const providedWeight = weight ? Number(weight) : 1;
        if (!weight)
            setWeight("1")

        if (providedWeight < 0.001)
            return;

        setIsNothingFound(false)
        setIsLoading(true)

        getQuote(
            originCountry?.countryCode ?? "",
            destinationCountry?.countryCode ?? "",
            providedWeight,
            weightUnit ?? WeightUnit.Kg,
            contactId ?? 2).then((response: any) => {

            let results: any[] = [];
            response?.data?.routes?.map((route: any) => {
                route?.results?.map((result: any) => {
                    result?.charges?.map((charge: any) => {
                        results.push(charge);
                    });
                });
            });

            if (results.length === 0) {
                setIsNothingFound(true)
            }
            setDeliveryMethods(results)

        }).catch((error: any) => {
            if (error?.response?.status === 401) {
                dispatch(setToken(null))
            }
        })
            .finally(() => setIsLoading(false))
    }

    useEffect(() => {
        dispatch(setToken(null))
    }, [dispatch])

    useEffect(() => {
        if (!token)
            getToken().then((response: any) => {
                const t = [response?.data?.["token_type"], response?.data?.["access_token"]].join(" ");
                dispatch(setToken(t));
                api.defaults.headers.common["Authorization"] = t;
            }).catch((error: any) => console.log(error));
        else if (!contactId) {
            getUserInfo().then((response: any) => {
                if (response?.data?.contactId) {
                    dispatch(setContactId(response?.data?.contactId))
                }
            })
        }

    }, [token, contactId]);

    useEffect(() => {
        setDeliveryMethods([])
    }, [destinationCountry])

    return (
        <div className={'calculator'}>
            <div className={'calculator-search'}>
                <div style={isDesktop ? {
                    maxWidth: '780px', width: "45%",
                    minWidth: '210px'
                } : {width: "100%"}}>
                    <CountryInput country={destinationCountry} setCountry={setDestinationCountry}/>
                </div>
                <div style={isDesktop ? {
                    maxWidth: '320px', width: "25%",
                    minWidth: '210px'
                } : {width: "100%"}}>
                    <WeightInput weight={weight} setWeight={setWeight} weightUnit={weightUnit}
                                 setWeightUnit={setWeightUnit}/>
                </div>
                <div style={isDesktop ? {} : {width: "100%"}}>
                    <button className="w-btn us-btn-style_1"
                            style={isDesktop ? {minWidth: "320px", height: '48px'} : {width: "100%", height: '48px'}}
                            onClick={() => handleSubmit()} disabled={isLoading}>
                        <span className="w-btn-label"
                              style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>{isLoading ?
                            <CircularProgress sx={{height: '20px', width: '20px'}}
                                              size={'sm'}/> : t('calculate')}</span>
                    </button>
                </div>
            </div>
            {deliveryMethods?.length > 0 ? <div className={'calculator-results'}>
                <div style={{
                    display: 'flex',
                    alignItems: "center",
                    justifyContent: "space-between",
                    paddingTop: "60px",
                    paddingBottom: "48px",
                    flexWrap: "wrap",
                    rowGap: "20px"
                }}>
                    <div className={"h3"}>{t('deliveryMethods.title')}</div>
                    {deliveryMethods?.length > 1 ? <div className={'calculator-results-sort'} onClick={() => {
                        setSort(!sort)
                    }}><div className={'h3'} style={{
                        fontWeight: 600,
                        fontSize: "1rem"
                    }}>{sort ? t('deliveryMethods.sort.max') : t('deliveryMethods.sort.min')}</div>
                        <Box
                            sx={{
                                width: 24,
                                height: 24,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                transform: sort ? 'rotate(180deg)' : '',
                                marginLeft: "8px"
                            }}>
                            <img
                                src={"https://trtshopping.com/wp-content/uploads/2023/06/dropdown-icon.svg"} alt={''}
                                width="12"/>
                        </Box>
                    </div> : null}
                </div>
                <DeliveryMethodsList deliveryMethods={deliveryMethods} weight={weight} weightUnit={weightUnit}
                                     sort={sort}/>

            </div> : isNothingFound ?
                <div className={'calculator-results-nothing-found'}>
                    <div className={'icon-box'}>
                        <img
                            width="16" src={'https://trtshopping.com/wp-content/uploads/2023/06/Icon.svg'}
                            alt={""}/>
                    </div>
                    <div className={"h3"}>{t('deliveryMethods.nothingFound.title')}</div>
                    <div className={"h4"}>{t('deliveryMethods.nothingFound.description1')}<br/>{t('deliveryMethods.nothingFound.description2')}
                    </div>
                </div> : null
            }
        </div>
    );
}

export default Calculator;
